import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — an open arched passage: narrow jambs at both sides of a
// 0.9 m opening and a stepped arched header (corner steps under the header
// beam approximate the curve). Same tile-long, 0.12 m thick, 2.6 m high
// plastered wall convention as wall-plain.
const PLASTER = "#e8e4dc";
const BASEBOARD = "#c9c2b6";

export const archway = defineModel({
  id: "archway",
  batchId: "modern",
  name: "Archway",
  tags: ["modern", "interior", "structure", "wall", "arch", "doorway", "opening"],
  summary: "An open arched passage through a plastered wall segment.",
  description:
    "A one-tile plastered wall of the Modern Living kit with an open arched " +
    "passage: a 0.9 m opening whose header steps inward to approximate an " +
    "arch (spring at about 1.75 m, crown at 2.15 m). Same 0.12 m thickness " +
    "and 2.6 m height as wall-plain.",
  tiles: { w: 1, h: 1 },
  footprint: 1.4,
  parts(): Part[] {
    return [
      // narrow full-height jambs at both sides of the 0.9 m opening
      { geometry: new THREE.BoxGeometry(0.05, 2.6, 0.12), color: PLASTER, position: [-0.475, 1.3, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 2.6, 0.12), color: PLASTER, position: [0.475, 1.3, 0] },
      // header above the arch crown (2.15 -> 2.6)
      { geometry: new THREE.BoxGeometry(1.0, 0.45, 0.12), color: PLASTER, position: [0, 2.375, 0] },
      // outer arch steps (1.75 -> 2.15, 0.15 wide at each side)
      { geometry: new THREE.BoxGeometry(0.15, 0.4, 0.12), color: PLASTER, position: [-0.375, 1.95, 0] },
      { geometry: new THREE.BoxGeometry(0.15, 0.4, 0.12), color: PLASTER, position: [0.375, 1.95, 0] },
      // inner arch steps (1.95 -> 2.15), leaving a 0.3 m wide crown
      { geometry: new THREE.BoxGeometry(0.15, 0.2, 0.12), color: PLASTER, position: [-0.225, 2.05, 0] },
      { geometry: new THREE.BoxGeometry(0.15, 0.2, 0.12), color: PLASTER, position: [0.225, 2.05, 0] },
      // baseboard stubs on the jambs
      { geometry: new THREE.BoxGeometry(0.05, 0.1, 0.15), color: BASEBOARD, position: [-0.475, 0.05, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 0.1, 0.15), color: BASEBOARD, position: [0.475, 0.05, 0] },
    ];
  },
  animations: [],
});
